var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('az-dialog',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":[],"items":[],"hide-actions":"","select-all":"","item-key":"id","loading":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }